// removed by extract-text-webpack-plugin
module.exports = {"indent":"_24tGFdurKbLODtxlkmP1hh"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Statistics/RecipientStatisticsOverall/RecipientStatisticsOverall.scss
// module id = 1383
// module chunks = 1